import { render } from "./elTable.vue?vue&type=template&id=032a0948&scoped=true"
import script from "./elTable.vue?vue&type=script&lang=js"
export * from "./elTable.vue?vue&type=script&lang=js"

import "./elTable.vue?vue&type=style&index=0&id=032a0948&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032a0948"]])

export default __exports__